<template>
  <div class="donut-chart-block block">
    <div class="donut-chart">
      <div id="part1" class="portion-block">
        <div class="circleL"></div>
      </div>
      <div id="part2" class="portion-block">
        <div class="circleL"></div>
      </div>
      <div id="part3" class="portion-block">
        <div class="circleL"></div>
      </div>
      <div id="part3" class="portion-block">
        <div class="circleL"></div>
      </div>
      <p class="center"></p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pagerLoaderComp',
  props: {}
}
</script>
<style scoped>
/* Demo */
.donut-chart {
  position: relative;
  width: 175px;
  height: 175px;
  margin: 0 auto 2rem;
  border-radius: 100%;
}

p.center {
  background: #babbbb;
  position: absolute;
  text-align: center;
  font-size: 28px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 145px;
  height: 145px;
  margin: auto;
  border-radius: 50%;
  line-height: 25px;
  padding: 15% 0 0;
}

.darkTheme p.center {
  background: #525252;
}

.portion-block {
  border-radius: 50%;
  clip: rect(0px, 200px, 200px, 100px);
  height: 100%;
  position: absolute;
  width: 100%;
}

.circleL {
  border-radius: 50%;
  clip: rect(0px, 100px, 200px, 0px);
  height: 100%;
  position: absolute;
  width: 100%;
  font-family: monospace;
  font-size: 1.5rem;
}

#part1 {
  transform: rotate(0deg);
}

#part1 .circleL {
  background-color: #e64c65;
  /*transform: rotate(76deg);*/
  animation: first 2s infinite;
}

#part2 {
  transform: rotate(100deg);
}

#part2 .circleL {
  background-color: #11a8ab;
  animation: second 2s infinite;
}

#part3 {
  transform: rotate(250deg);
}

#part3 .circleL {
  background-color: #ecc257;
  animation: third 2s infinite;
}

/* Animation */
@keyframes first {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(98deg);
  }
}

@keyframes second {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(148deg);
  }
}

@keyframes third {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(109deg);
  }
}

@media (max-width: 991.98px) {
  .donut-chart-block {
    transform: scale(0.5);
  }
}</style>